const BASE_URL = process.env.REACT_APP_API_URL;
const LANG = process.env.REACT_APP_LANGUAGE;

const Links = {
  LOGIN_ADMIN: `${BASE_URL}/admin-manager/${LANG}/login`,
  DELETE_ADMIN: `${BASE_URL}/admin-manager/${LANG}/deleteProfile`,
  REGISTER_ADMIN: `${BASE_URL}/admin-manager/${LANG}/register`,
  FORGOT_PASSWORD: `${BASE_URL}/admin-manager/${LANG}/forgotPassword`,
  GET_MEMBERS: `${BASE_URL}/admin-manager/${LANG}/getAllMembers`,
  ADD_MEMBER: `${BASE_URL}/admin-manager/${LANG}/addNewMember`,
  UPDATE_MEMBER: `${BASE_URL}/admin-manager/${LANG}/updateMember`,
  DELETE_MEMBER: `${BASE_URL}/admin-manager/${LANG}/deleteMember`,
  GET_TRAINERS: `${BASE_URL}/admin-manager/${LANG}/getAllTrainers`,
  GET_MEMBERSHIP_PLANS: `${BASE_URL}/admin-manager/${LANG}/getAllMembershipPlans`,
  ADD_TRAINER: `${BASE_URL}/admin-manager/${LANG}/addTrainer`,
  ADD_MEMBERSHIP_PLAN: `${BASE_URL}/admin-manager/${LANG}/addMembershipPlan`,
  UPDATE_MEMBERSHIP_PLAN: `${BASE_URL}/admin-manager/${LANG}/updateMembershipPlan`,
  UPDATE_TRAINER: `${BASE_URL}/admin-manager/${LANG}/updateTrainer`,
  DELETE_TRAINER: `${BASE_URL}/admin-manager/${LANG}/deleteTrainer`,
  DELETE_MEMBERSHIP_PLAN: `${BASE_URL}/admin-manager/${LANG}/deleteMembershipPlan`,
  MESSAGE_MEMBER: `${BASE_URL}/admin-manager/${LANG}/sendMessageToMembers`,
  GET_RECORDS: `${BASE_URL}/admin-manager/${LANG}/getAllRecords`,
  GET_QUERIES: `${BASE_URL}/admin-manager/${LANG}/getAllQueries`,
  GET_EARNINGS: `${BASE_URL}/admin-manager/${LANG}/getMonthlyEarnings`,
  GET_QUERIES_FOLLOWUPS: `${BASE_URL}/admin-manager/${LANG}/getQueryFollowups`,
  ADD_QUERY: `${BASE_URL}/admin-manager/${LANG}/addNewQuery`,
  GET_DASHBOARD_DATA: `${BASE_URL}/admin-manager/${LANG}/getAllDashboardData`,
  CHANGE_PASSWORD: `${BASE_URL}/admin-manager/${LANG}/changePassword`,
  UPDATE_PROFILE: `${BASE_URL}/admin-manager/${LANG}/updateProfile`,
  COMPLETE_OR_RESCHEDULE_QUERY: `${BASE_URL}/admin-manager/${LANG}/completeOrRescheduleAQuery`,
  COMPLETE_OR_RESCHEDULE_PAYMENT: `${BASE_URL}/admin-manager/${LANG}/completeOrReschedulePendingPayment`,
  GET_BATCHES: `${BASE_URL}/admin-manager/${LANG}/getAllBatches`,
  GET_PROFILE: `${BASE_URL}/admin-manager/${LANG}/getProfile`,
  ADD_BATCH: `${BASE_URL}/admin-manager/${LANG}/addBatch`,
  ADD_GYM: `${BASE_URL}/admin-manager/${LANG}/addGym`,
  UPDATE_GYM: `${BASE_URL}/admin-manager/${LANG}/updateGym`,
  UPDATE_BATCH: `${BASE_URL}/admin-manager/${LANG}/updateBatch`,
  DELETE_BATCH: `${BASE_URL}/admin-manager/${LANG}/deleteBatch`,
  DELETE_GYM: `${BASE_URL}/admin-manager/${LANG}/deleteGym`,
  GET_PAYMENT_HISTORY: `${BASE_URL}/admin-manager/${LANG}/getPaymentHistory`,
  ADD_PAYMENT: `${BASE_URL}/admin-manager/${LANG}/addPayment`,
  DELETE_PAYMENT: `${BASE_URL}/admin-manager/${LANG}/deletePaymentHistory`,
  UPDATE_PAYMENT: `${BASE_URL}/admin-manager/${LANG}/updatePaymentHistory`,
  GET_PENDING_PAYMENT: `${BASE_URL}/admin-manager/${LANG}/getPendingPaymentMembers`,
  GET_DIET_PLANS: `${BASE_URL}/admin-manager/${LANG}/getAllDietPlans`,
  ADD_DIET_PLAN: `${BASE_URL}/admin-manager/${LANG}/addDietPlan`,
  UPDATE_DIET_PLAN: `${BASE_URL}/admin-manager/${LANG}/updateDietPlan`,
  DELETE_DIET_PLAN: `${BASE_URL}/admin-manager/${LANG}/deleteDietPlan`
};

export default Links;
